<header class="header-2">
  <div class="branding">
    <span class="title">{{ 'Checklisten verwalten' | mrTranslate }}</span>
  </div>
  <div class="header-actions">
    <clr-dropdown>
      <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
        <cds-icon shape="cog" />
      </button>
      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
        <a (click)="addChecklist()" clrDropdownItem>{{ 'Neue Checkliste erstellen' | mrTranslate }}</a>

        @if (selchecklist) {
          <div>
            <a (click)="saveAsChecklist()" clrDropdownItem>{{ 'Checkliste speichern unter...' | mrTranslate }}</a>
            <a (click)="deleteChecklist()" clrDropdownItem>{{ 'Checkliste löschen' | mrTranslate }}</a>
          </div>
        }
      </clr-dropdown-menu>
    </clr-dropdown>
    <a href="javascript://" class="nav-link nav-icon">
      <cds-icon shape="times" (click)="close()"></cds-icon>
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper" style="height: calc(100% + 60px)">
  <div id="objekttpyWrapper">
    <div class="clr-row" id="groupSelectionRow">
      <div class="clr-col-12 text-center">
        <clr-select-container style="display: inline-block">
          <select clrSelect #sel [(ngModel)]="selectedOption" (change)="selectedNamechanged(sel.value)">
            @for (item of checklistennamen; track item) {
              <option [value]="item.Titel">
                {{ item.Titel }}
              </option>
            }
          </select>
        </clr-select-container>

        <div class="inline-block float-right" style="margin-top: 15px">
          @if (cansortup) {
            <cds-icon size="24" shape="arrow" (click)="sortUp()" class="cursor-pointer" />
          }
          @if (cansortdown) {
            <cds-icon
              size="24"
              shape="arrow"
              (click)="sortDown()"
              class="cursor-pointer"
              style="transform: rotate(180deg)" />
          }
        </div>
      </div>

      <div id="objectSelectionWrapper" class="clr-row">
        <div class="clr-col" style="max-width: calc(calc(100% - 8.3333333333%) / 2)">
          <div>{{ 'Alle möglichen Prüfarten' | mrTranslate }}</div>

          <div class="limit-height">
            @if (stammobjekte) {
              <clr-datagrid
                class="datagrid-compact"
                [clrDgSelectionType]="'multi'"
                [(clrDgSelected)]="selectedStammList"
                [clrDgRowSelection]="true">
                @for (column of stammobjekte.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                      {{ column.id | mrTranslate | titlecase }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of stammobjekte.rows" [clrDgItem]="row">
                  @for (cell of stammobjekte.columns; track cell) {
                    <clr-dg-cell>{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ stammobjekte.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
        </div>

        <div id="objectControl" class="clr-col-1">
          <a
            href="javascript:void(0);"
            [ngClass]="{ disabled: selectedStammList.length == 0 }"
            (click)="executeToAdd()">
            <cds-icon shape="circle-arrow" direction="right" size="72" style="color: green" />
          </a>
          <a
            href="javascript:void(0);"
            [ngClass]="{ disabled: selectedPOList.length == 0 }"
            (click)="executeToRemove()">
            <cds-icon shape="circle-arrow" direction="left" size="72" style="color: red" solid="true" />
          </a>
        </div>
        <div class="clr-col" style="max-width: calc(calc(100% - 8.3333333333%) / 2)">
          <div>{{ 'Prüfarten in Checkliste' | mrTranslate }}</div>
          <div class="limit-height">
            @if (groupObjects) {
              <clr-datagrid
                class="datagrid-compact"
                [clrDgSelectionType]="'multi'"
                [(clrDgSelected)]="selectedPOList"
                (clrDgSelectedChange)="selectionPOChanged($event)"
                cdkDropList
                [cdkDropListData]="groupObjects.rows"
                (cdkDropListDropped)="moveDrop($event)"
                [clrDgRowSelection]="true">
                <clr-dg-column class="fixed-cell" />
                @for (column of groupObjects.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container
                      *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sprueid', 'titel', 'sortid'] }">
                      {{ column.id | mrTranslate | titlecase }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of groupObjects.rows" [clrDgItem]="row" cdkDrag [cdkDragData]="row">
                  <clr-dg-cell class="fixed-cell" cdkDragHandle>
                    <cds-icon shape="ellipsis-vertical" size="10" />
                  </clr-dg-cell>
                  @for (cell of groupObjects.columns; track cell) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ groupObjects.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<clr-modal [(clrModalOpen)]="isChecklisteAddVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ modaltitel | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical">
      <div class="clr-row">
        <div class="clr-col-12">
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 300px">
              <input
                id="_aufgroup_name_new"
                class="clr-input combobox"
                placeholder="{{ 'Name' | mrTranslate }}"
                #_checklistename />
            </div>
          </div>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editCheckliste()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isChecklisteAddVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
